import { ActivatedRoute } from "@angular/router";
import AIDecorator from "./AIDecorator";
import { Injector } from "@angular/core";

export default class AIGenericForm extends AIDecorator {

    constructor(
      public route: ActivatedRoute,
      public name = 'AIGenericForm',
      public injector: Injector
    ) {
      super(route, name, injector);
    }

    processFilter(filter, config) {
        var currentData = this.storageService.getSessionStorageDataSync('currentData');
        filter = this.baseService.buildDyanamicStr((filter) ? filter : '', { data: currentData });
        return filter
    }
}
